export const COLLECTION_DONGENG = 'thumb_lib_dongeng';
export const COLLECTION_THUMB_HOMEPAGE = 'thumb_homepage';
export const COLLECTION_THUMB_LANDS = 'thumb_landscape';
export const COLLECTION_WISHLIST = 'whislist';
export const COLLECTION_ULASAN = 'ulasan';
export const COLLECTION_ANGGOTA = 'anggota_kelompok';
export const COLLECTION_USER = 'user';
export const COLLECTION_SLIDER = 'slider';
export const KATEGORI = 'category';
export const INDEX = 'index';
export const KATEGORI_POPULER = 'populer';
export const KATEGORI_SEGERA = 'segera';
export const RILIS = 'rilis';
export const BARU = 'baru';
export const CERITA = 'cerita';
export const THUMB_CERITA_KELINCI_KURA = 'Kelinci dan Kura-Kura';
export const THUMB_CERITA_KANCIL_HARIMAU = 'Kancil dan Harimau';
export const THUMB_CERITA_KANCIL_BUAYA = 'Kancil dan Buaya';
export const THUMB_CERITA_BEBEK = 'Bebek Buruk Rupa';
export const TANGGAL = 'tanggal';
export const DESC = 'desc';
export const RELEVAN = 'relevan';
export const RELEVAN_VALUE = 'ya';
